import React from "react";

import { useTranslation } from "@refinedev/core";

import { List, Paper, Typography } from "@mui/material";

import { NavigationCard } from "./NavigationCard";

export type ProfileSecurityOption = "change-name" | "change-email" | "change-password" | "change-phone" | "change-mfa";

interface ProfileAndSecurityPanelProps {
  onOptionSelect: (option: ProfileSecurityOption) => void;
}

export const ProfileAndSecurityPanel: React.FC<ProfileAndSecurityPanelProps> = ({ onOptionSelect }) => {
  const { translate } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary" mb={2}>
        {translate("pages.profile.sections.profileAndSecurity")}
      </Typography>
      <Paper variant="outlined">
        <List disablePadding>
          <NavigationCard
            title={translate("pages.profile.options.changeName")}
            onClick={() => onOptionSelect("change-name")}
          />
          <NavigationCard
            title={translate("pages.profile.options.changeEmail")}
            onClick={() => onOptionSelect("change-email")}
          />
          <NavigationCard
            title={translate("pages.profile.options.changePassword")}
            onClick={() => onOptionSelect("change-password")}
          />
          <NavigationCard
            title={translate("pages.profile.options.changePhone")}
            onClick={() => onOptionSelect("change-phone")}
          />
          <NavigationCard
            title={translate("pages.profile.options.changeMfa")}
            onClick={() => onOptionSelect("change-mfa")}
          />
        </List>
      </Paper>
    </>
  );
};
